import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {TipHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function VinoCerasuolo() {
    const {theme} = useSingleTheme('tipologia');
    const tipologia_Theme = theme;
    const {articles} = useArticles('tipologia');
    const article = articles.slice(3, 4) || [];
    const articles_VRose = article[0]; 
    const {paragraphs} = useParagraphs('tipologia_4');

    return (
        <section>
            {theme && <TipHeadLinks title={tipologia_Theme.tema_titolo} /> }
            <ThemesScreen theme={tipologia_Theme} article={articles_VRose} paragraphs={paragraphs}/> 
        </section>
    )
}
export default VinoCerasuolo;
